import { TextField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { AddMiniIcon } from '@calendly/ui/components/icons';
import { MinimalButton } from '@calendly/ui/components/minimal-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useBooleanState } from 'hooks/useBooleanState';
import { isNoTouchDevice } from 'services/touch_device_detection';
import { popupSelector } from '../selectors';
import { useStateValue } from '../state_provider';
const styledTextFieldCss = "s1m6lfzg";
const StyledTextField = forwardRef((props, ref) => <TextField ref={ref} {...props} className={classNames(styledTextFieldCss, props.className)} />);
export const AdditionalInfo = () => {
  const state = useStateValue();
  const {
    data: {
      additional_info: defaultAdditionalInfo
    }
  } = popupSelector(state);
  return <AdditionalInfoInput initialValue={defaultAdditionalInfo} />;
};
const AdditionalInfoInput = ({
  initialValue
}) => {
  const [inputVisible, showInput, hideInput] = useBooleanState(!!initialValue);
  const toggleInput = inputVisible ? hideInput : showInput;
  if (inputVisible) {
    return <StyledTextField name="additionalInfo" aria-label={I18n.t('publisher.event_types.location.include_additional_information')} type="textarea" maxLength={255} autoFocus={isNoTouchDevice()} />;
  }
  return <MinimalButton spacingTop={8} fontSize="medium" onClick={toggleInput}>
      <AddMiniIcon />
      {I18n.t('publisher.event_types.location.include_additional_information')}
    </MinimalButton>;
};

require("./additional_info.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./additional_info.js");